import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import SearchIcon from '@mui/icons-material/Search';
import "./search.css"

const SearchBar = () => {
  const [placeholderIndex, setPlaceholderIndex] = useState(0);
  const placeholders = ["Find bangles...", "Explore products...","Search jewellery...","Search products that last forever..."];

  const isMobile = useMediaQuery({ query: "(min-width: 624px)" });
  useEffect(() => {
    const interval = setInterval(() => {
      setPlaceholderIndex((prevIndex) => (prevIndex + 1) % placeholders.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  
  return (
    <>
   <div className="search">
  <input  className="searchbar" type="text" placeholder={placeholders[placeholderIndex]} />
  <SearchIcon className="search-icon" sx={{ color: "#cb835b" }} />

</div>
      
    </>
  );
};

export default SearchBar;
